import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=c1bdc35a&"
import script from "./AddressBlock.vue?vue&type=script&lang=ts&"
export * from "./AddressBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GSimpleListCard from 'shared/global/components/SimpleListCard.vue'
installComponents(component, {GSimpleListCard})
